import React, { useEffect, useRef, useState } from 'react'

// react redux
import { connect } from "react-redux";

// bootstrap
import { Image, Spinner } from 'react-bootstrap';

// react router
import { useHistory, Link } from 'react-router-dom';

// react slick
import Slider from "react-slick";

// icons
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";

// slider images
import sliderImg1 from 'assets/images/sliders/1.jpg'

// api
import { getSliders_API } from 'utlis/Apis/Sliders_API';
// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// react toastify
import { toast } from "react-toastify";

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";

function SliderComponent(props) {
	// props
	const { setGlobalLoading } = props

	// states
	const [sliders, setSliders] = useState([])

	// refs
	let slider = useRef(null);

	useEffect(() => {
		// global loading
		setGlobalLoading(true)

		// getting data
		getSliders_API().then(res => {
			// global loading
			setGlobalLoading(false)

			const resData = res.data;

			console.log("res ", res);

			// if success
			if (resData?.success) {
				setSliders(resData.data)
			}

			// if error
			if (resData?.error) {
				// dismissing all the previous toasts first
				toast.dismiss();

				// showing the error message
				toast.error(resData?.message || "Unknown error occured", {
					autoClose: 2500,
				});
			}
		}).catch((err) => {
			console.log(`${ERROR_WHILE__NAME} getSliders_API `, err.message);

			// dismissing all the previous toasts first
			toast.dismiss();

			// showing the error message
			toast.error(UNKNOWN_ERROR_OCCURED, {
				autoClose: 2500,
				onClose: () => {
					// disabling global loading
					setGlobalLoading(false)
				},
			});
		})
	}, [setGlobalLoading])

	const goToLink = (ev, link) => {
		console.log("Link");
	}

	return (
		<div className="slider-container-outer" id="home-slider">
			<div className="slider-container position-relative overflow-hidden" style={{ marginTop: -16, borderTop: "1px solid #333" }}>
				<Slider
					ref={(c) => (slider = c)}

					dots={false}
					speed={500}
					slidesToShow={1}
					slidesToScroll={1}
					arrows={false}
					autoPlay={true}
					autoplaySpeed={1000}
					draggable={false}
					lazyLoad={true}
				>
					{
						/* slider item */
						sliders?.length ? sliders.map(item => (
							<div key={item.slider_id} className="slider-item cursor-pointer position-relative" onClick={ev => goToLink(ev, item.link)}>
								<Image src={item.image} alt="slider-img" fluid className="w-100" onLoad={ev => ev.target.nextElementSibling.remove()} />
								
								{/* lazy loading */}
								<div 
									className="lazy-loading px-3 d-flex align-items-center justify-content-center position-absolute h-100 w-100" 
									style={{ left: 0, top: 0, zIndex: 9, backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>
									<Spinner size="sm" animation="border" />
								</div>
							</div>
						)) : null
					}
				</Slider>

				{/* slider buttons */}
				<div className="slider-buttons">
					<a href="/" className="icon position-absolute left" onClick={ev => {
						ev.preventDefault()

						slider.slickPrev()
					}}>
						<BsChevronLeft fontSize="26" />
					</a>
					<a href="/" className="icon position-absolute right" onClick={ev => {
						ev.preventDefault()

						slider.slickNext()
					}}>
						<BsChevronRight fontSize="26" />
					</a>
				</div>
			</div>
		</div>

	)
}

const getDataFromStore = (state) => {
    return {
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(SliderComponent);